<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="handleClick('insert')">新增</el-button>
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.coin_name" placeholder="请输入钱币名称" class="header-input" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.coin_content" placeholder="请输入钱币内容" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="60">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="coinName" label="钱币名称" width="200"></el-table-column>
            <el-table-column prop="coinContent" label="钱币描述"></el-table-column>
            <el-table-column prop="coinDate" label="最近修改时间" width="160">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.coinDate) }}
                </template>
            </el-table-column>
            <el-table-column prop="coinImages" label="钱币图片" width="90">
                <template slot-scope="scope">
                    <div style="position: relative; width: 50px; height: 50px;" v-if="scope.row.coinImages">
                        <el-image style="width: 50px; height: 50px;" :src="getFirstImageSrc(scope.row.coinImages)" fit="cover"
                        :preview-src-list="getImageSrcList(scope.row.coinImages)"></el-image>
                        <div v-if="scope.row.coinImages.split(',').length > 1" style="position: absolute; background-color: #FF0000; top: 0px; right: 0px; z-index: 99; width: 20px; height: 20px; line-height: 20px; text-align: center; color: #FFFFFF; font-size: 12px; border-radius: 50%;">{{ scope.row.coinImages.split(",").length }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="60%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="钱币名称">
                        <el-input v-model="handleInfo.coinName"></el-input>
                    </el-form-item>
                    <el-form-item label="钱币描述">
                        <el-input type="textarea" :rows="5" v-model="handleInfo.coinContent"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="钱币图片">
                        <div class="upload-wrapper">
                            <div class="upload-item" v-for="(img, index) in getFiles('')">
                                <el-image class="upload-image" :src="getThumbImageSrc(img)" fit="cover" :preview-src-list="[getImageSrc(img)]"></el-image>
                                <div @click="uploadRemove('coinImages', index)" class="upload-remove">删除</div>
                            </div>
                            <el-upload :data="{ column: 'coinImages' }" accept=".jpg,.jpeg,.bmp,.png" :multiple="true" :headers="uploadHeaders"
                                :action="uploadUrl" :show-file-list="false" :on-success="uploadSuccessMulti">
                                <i class="el-icon-plus upload-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item> -->

                    <el-form-item label="钱币图片">
                        <div class="upload-wrapper">
                            <div class="upload-item" v-for="(img, index) in getFiles('coinImages')">
                                <!-- <el-image class="upload-image" :src="getImageSrc(img)" fit="cover" -->
                                <el-image class="upload-image" :src="getThumbImageSrc(img)" fit="cover"
                                    :preview-src-list="getImageArrayByArrIndex(getFiles('coinImages'), index)"></el-image>
                                <div class="upload-toolbar">
                                    <div @click="uploadRemove('coinImages', index)" class="upload-tool">删除</div>
                                </div>
                            </div>
                            <div class="upload-item"
                                style="border: 1px dashed #CCCCCC; text-align: center; line-height: 100px;"
                                v-if="uploadLoading && uploadColumn == 'coinImages'">
                                上传中...
                            </div>
                            <el-upload :data="{ column: 'coinImages' }" accept=".jpg,.jpeg,.bmp,.png"
                                :multiple="true" :headers="uploadHeaders" :action="uploadUrl" :show-file-list="false"
                                :on-success="uploadSuccessMulti" :before-upload="uploadBefore"
                                @click.native="uploadClick('coinImages')">
                                <i class="el-icon-plus upload-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, uploadMixin, imageMixin, enumMixin],
    data: function () {
        return {
        }
    },
    methods: {

    },
    created: async function () {
        this.tag = "COIN";
        this.uploads.push({
            column: "coinImages",
            files: []
        });
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>